export default __webpack_public_path__ + "static/media/catch-button.png";